import { createContext, useContext } from "react"

export type PageHeaderContextValue = {
  /** Current pathname (e.g. `/dashboard`) — used by items to derive their own active state */
  currentPath: string
  /** Id attached to the heading element — used by tab links to provide a unique accessible name to the nav landmark region */
  headingId: string
}

export const PageHeaderContext = createContext<PageHeaderContextValue | null>(
  null
)

export function usePageHeaderContext(): PageHeaderContextValue {
  const context = useContext(PageHeaderContext)
  if (!context)
    throw new Error("usePageHeaderContext must be used within a PageHeaderRoot")
  return context
}
